<template>
  <ReassuranceItem has-link @click="openReassuranceModal">
    <template #icon>
      <IconQuality class="h-24 w-24 md:h-32 md:w-32" />
    </template>
    <template #title>
      <div>
        {{ i18n(translations.freeReturn, { day: coolingOffDays }) }}
      </div>
      <div v-if="warrantyDelay">
        {{ warrantyDelay }}
      </div>
    </template>
  </ReassuranceItem>
  <ReassuranceModal />
</template>

<script lang="ts" setup>
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { openModal } from '@ds/components/ModalBase'
import { IconQuality } from '@ds/icons/IconQuality'

import { MODAL_NAMES } from '~/scopes/product/constants'

import ReassuranceItem from '../ReassuranceItem/ReassuranceItem.vue'
import ReassuranceModal from '../ReassuranceModal/ReassuranceModal.vue'

import translations from './ItemReassurance.translations'

const props = withDefaults(
  defineProps<{
    warrantyDelay?: string | null
    tracking: Record<string, string>
  }>(),
  { warrantyDelay: '' },
)

const i18n = useI18n()
const { trackClick } = useTracking()
const { features } = useMarketplace()
const { coolingOffDays } = features

function openReassuranceModal(event: MouseEvent) {
  openModal(MODAL_NAMES.REASSURANCE, event)
  trackClick(props.tracking)
}
</script>
